import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { FlexBox, Orientation, InputLabel, Heading, Typography } from '@lumapps/lumx/react';

import type { FilterProps } from '../Filter/types';

import './index.scss';

const CLASSNAME = 'grouped-filter';

/**
 * Component that displays a filter in the mode `GROUPED`.
 * @family Filters
 * @param FilterProps
 * @returns GroupedFilter
 */
export const GroupedFilter: React.FC<FilterProps> = ({
    title,
    children,
    className,
    hideTitle = false,
    isFieldset = false,
    titleAs = 'label',
    titleId,
}) => {
    const { block, element } = useClassnames(CLASSNAME);
    const baseTitleProps = {
        className: element('title'),
        typography: Typography.subtitle1,
        id: titleId,
    };

    const titleAsLabel = titleAs === 'label';

    const Title =
        titleAsLabel && titleId ? (
            <InputLabel {...baseTitleProps} htmlFor={titleId}>
                {title}
            </InputLabel>
        ) : (
            <Heading as="h4" {...baseTitleProps} id={titleId}>
                {title}
            </Heading>
        );

    return (
        <FlexBox
            as={isFieldset ? 'fieldset' : 'div'}
            orientation={Orientation.vertical}
            className={block([className])}
            aria-labelledby={isFieldset ? titleId : undefined}
        >
            {!hideTitle ? Title : null}

            <div className={element('content')}>{children}</div>
        </FlexBox>
    );
};
